module.exports = __webpack_public_path__ + "img/dcCorte.a85569cd.jpg";